import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';
import { useGetLoginUserInfo } from '../../api/auth/auth';
import { useDefaultOptions } from '../../hooks/api';
import ErrorComponent from '../atoms/ErrorComponent';
import WaitComponent from '../atoms/WaitComponent';
import Header from '../modules/Header';
import SideNavi from '../modules/SideNavi';
import NotLogin from '../pages/login-test/NotLogin';

const editModeContext = createContext<boolean>(false);
const setEditModeContext = createContext<Dispatch<SetStateAction<boolean>>>(() => {
  /* do nothing */
});

function EditModeProvider({ children }: { children: ReactNode }) {
  const [editMode, setEditMode] = useState<boolean>(false);

  return (
    <editModeContext.Provider value={editMode}>
      <setEditModeContext.Provider value={setEditMode}>{children}</setEditModeContext.Provider>
    </editModeContext.Provider>
  );
}

export const useEditModeValue = () => useContext(editModeContext);
export const useEditModeSetValue = () => useContext(setEditModeContext);

/**
 * ログイン済みのページのレイアウトコンポーネント
 * @returns
 */
function LoginedLayout() {
  const {
    i18n: { language },
  } = useTranslation();
  const defaultOptions = useDefaultOptions(language);
  const location = useLocation();
  const manuPage = location.pathname.indexOf('/productions/sections/') !== -1;

  // ユーザー情報を取得
  const loginUserInfo = useGetLoginUserInfo(defaultOptions);

  // ユーザー情報取得中の場合は、そのことを表示
  if (loginUserInfo.isLoading) {
    return <WaitComponent />;
  }

  // ユーザー情報取得中の場合はエラー表示
  // TODO: ログイン画面へのリダイレクト
  if (loginUserInfo.isError) {
    return <NotLogin />;
    return <ErrorComponent error={loginUserInfo.error} />;
  }

  // ユーザー情報が取得できた場合は画面を表示
  return (
    <div id="container">
      <EditModeProvider>
        <Header loginUserInfo={loginUserInfo.data.data} dispHeaderNavi={!manuPage} />
        <div id="contents" className="contents">
          <div id="contents-in" className="contents-in inside">
            <SideNavi />
            <Outlet />
          </div>
        </div>
      </EditModeProvider>
    </div>
  );
}

export default LoginedLayout;
